import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "searchContainer", "searchInput", "resultsList", "selectedDisplay", "subjectTypeField", "subjectIdField"]
  static values = {
    items: Array
  }

  connect() {
    this.allItems = this.itemsValue || []
    this.updateVisibility()

    // Show initial results if type is selected but no item chosen yet
    if (this.typeSelectTarget.value && !this.subjectIdFieldTarget.value) {
      this.filterResults()
    }
  }

  typeChanged() {
    const type = this.typeSelectTarget.value
    this.subjectTypeFieldTarget.value = type
    this.subjectIdFieldTarget.value = ""
    this.searchInputTarget.value = ""
    this.clearSelection()
    this.updateVisibility()
    if (type) {
      this.filterResults()
    }
  }

  updateVisibility() {
    const hasType = this.typeSelectTarget.value !== ""
    this.searchContainerTarget.classList.toggle("hidden", !hasType)
  }

  filterResults() {
    const type = this.typeSelectTarget.value
    const query = this.searchInputTarget.value.trim().toLowerCase()

    const filtered = this.allItems.filter(item => {
      if (item.type !== type) return false
      if (query && !item.name.toLowerCase().includes(query)) return false
      return true
    })

    this.renderResults(filtered)
  }

  renderResults(items) {
    if (items.length === 0) {
      this.resultsListTarget.innerHTML = `
        <p class="text-sm text-beige-500 italic py-2">No items found</p>
      `
      return
    }

    const html = items.slice(0, 10).map(item => `
      <button type="button"
              class="w-full text-left px-3 py-2 rounded-md hover:bg-beige-100 transition-colors flex items-center gap-3"
              data-action="attach-to#selectItem"
              data-item-id="${item.id}"
              data-item-name="${this.escapeHtml(item.name)}"
              data-item-type="${item.type}">
        ${item.image ? `<img src="${item.image}" class="w-8 h-8 rounded object-cover" />` : `<div class="w-8 h-8 rounded bg-beige-200 flex items-center justify-center"><svg class="w-4 h-4 text-beige-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg></div>`}
        <span class="text-sm font-medium text-beige-800">${this.escapeHtml(item.name)}</span>
      </button>
    `).join("")

    this.resultsListTarget.innerHTML = html

    if (items.length > 10) {
      this.resultsListTarget.innerHTML += `
        <p class="text-xs text-beige-500 pt-2">Showing first 10 results. Type to narrow down.</p>
      `
    }
  }

  selectItem(event) {
    const button = event.currentTarget
    const id = button.dataset.itemId
    const name = button.dataset.itemName
    const type = button.dataset.itemType

    this.subjectIdFieldTarget.value = id

    this.selectedDisplayTarget.innerHTML = `
      <div class="flex items-center justify-between p-3 bg-beige-50 rounded-lg border border-beige-200">
        <div class="flex items-center gap-3">
          <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          <span class="text-sm font-medium text-beige-800">${this.escapeHtml(name)}</span>
          <span class="text-xs text-beige-500">(${type})</span>
        </div>
        <button type="button" class="text-beige-500 hover:text-beige-700" data-action="attach-to#clearSelection">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    `
    this.selectedDisplayTarget.classList.remove("hidden")
    this.searchContainerTarget.classList.add("hidden")
  }

  clearSelection() {
    this.subjectIdFieldTarget.value = ""
    this.selectedDisplayTarget.innerHTML = ""
    this.selectedDisplayTarget.classList.add("hidden")
    if (this.typeSelectTarget.value) {
      this.searchContainerTarget.classList.remove("hidden")
      this.filterResults()
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
